module.exports = __webpack_public_path__ + "img/Code-vestimentaire-web.b8b2ee60.jpeg";